(function () {
    'use strict';

    angular
        .module('app', [
            'ngAnimate',
            'ngCookies',
            'ngStorage',
            'ngSanitize',
            'ngTouch',
            'ui.router',
            'ui.bootstrap',
            'toastr',
            'oitozero.ngSweetAlert',
            'cfp.loadingBar',
            'underscore',
            'smart-table',
            'ngStorage',
            /* Feature modules */
            'app.auth',
            'app.register'
        ]);

})();

(function() {
'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .factory('HttpRequestTimeoutInterceptor', HttpRequestTimeoutInterceptor);

    /** @ngInject */
    function HttpRequestTimeoutInterceptor($q, HttpPendingRequestsService) {

        var service = {
            request: request,
            responseError: responseError
        };

        function request(config) {
            config = config || {};
            if(angular.isUndefined(config.timeout) && !config.noCancelOnRouteChange) {
                config.timeout = HttpPendingRequestsService.newTimeout();
            }
            return config;
        }

        function responseError(response) {
            if(response.config.timeout.isGloballyCancelled) {
                return $q.defer().promise;
            }
            return $q.reject(response);
        }

        return service;
    }
})();
(function () {
    'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, HttpPendingRequestsService) {
        $rootScope.$on('$stateChangeSuccess', function (event, newUrl, oldUrl) {
            if (newUrl != oldUrl) {
                HttpPendingRequestsService.cancelAll();
            }
        });
    }

})();

(function() {
    'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .config(config);

    /** @ngInject */
    function config($httpProvider) {

        $httpProvider.interceptors.push('HttpRequestTimeoutInterceptor');

    }

})();

(function() {
'use strict';
    /**
     * @author Albert Brand <https://github.com/AlbertBrand/>
     * @author Sean Perkins <sean@meetmaestro.com>
     */
    angular
        .module('app')
        .service('HttpPendingRequestsService', HttpPendingRequestsService);

    /** @ngInject */
    function HttpPendingRequestsService($q) {

        var cancelPromises = [];

        var service = {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return service;

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .directive('ngEnter', ngEnter);

    function ngEnter() {
        return function(scope, element, attrs) {
            element.bind('keydown keypress', function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('smart-table')
        .filter('smartTableFilter', smartTableFilter);

    /** @ngInject */
    function smartTableFilter(_) {
        return function (array, expression) {
            var expression = angular.copy(expression);
            return _.filter(array, function (object) {
                if (angular.isUndefined(expression.$)) {
                    var searchTerms = _.keys(expression);
                    return _.filter(searchTerms, function(searchTerm) {
                        var value = object[searchTerm];
                        if(angular.isString(value)) {
                            return value.toLowerCase().indexOf(expression[searchTerm].toLowerCase()) !== -1;
                        }
                        if (angular.isNumber(value)) {
                            var dateValue = new Date(value);
                            if (isNaN(dateValue))
                                return value.toString().indexOf(expression[searchTerm].toLowerCase()) !== -1;
                            else 
                                return dateValue.toString().toLowerCase().indexOf(expression[searchTerm].replace(/,/g, '').toLowerCase()) !== -1;
                        }
                        return false;
                    }).length === searchTerms.length;
                }
                else {
                    var values = _.values(object);
                    return _.find(values, function (value) {
                        if (angular.isUndefined(expression.$)) {
                            return true;
                        }
                        if (angular.isArray(value))
                            value = value.join(', ');
                        if (angular.isString(value))
                            return value.toLowerCase().indexOf(expression.$.toLowerCase()) !== -1;
                        if (angular.isNumber(value)) {
                            var dateValue = Date.parse(value);
                            if (isNaN(dateValue))
                                return value.toString().indexOf(expression.$.toLowerCase()) !== -1;
                            else
                                return dateValue.toString().indexOf(expression.$.toLowerCase()) !== -1;
                        }
                        return false;
                    });
                }
            });
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .factory('API', API);

    /** @ngInject */
    function API($log, $http, $state, $q, $location) {

        var host;

        var service = {
            getRequest: getRequest,
            get: getRequest,
            postRequest: postRequest,
            putRequest: putRequest,
            deleteRequest: deleteRequest,
            query: queryRequest
        };

        initAPIHost();

        return service;

        function initAPIHost() {
            if($location.port() === 3000 || $location.port() === 3002) {
                host = 'http://proxi/api/';
            }
            else {
                host = 'http://proxi.devonite.com/core/api/';
            }
        }

        function syncToken() {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        }

        function queryRequest(url) {

            syncToken();

            var deferred = $q.defer();

            var queryNext = function(requestURL) {

                if(requestURL.indexOf('/?page=') !== -1)
                    requestURL = requestURL.replace('/?page=', '?page=');

                $http.get(requestURL).then(function(response) {

                    var responseData = response.data;
                    var pagination = responseData.meta.pagination;

                    deferred.notify(responseData.data);

                    if(angular.isDefined(pagination.links.next))
                        queryNext(pagination.links.next);
                    else
                        deferred.resolve();
                }, function(response) {
                    $log.error('Pagination ('+requestURL+')', response);
                    if(response.status === 401 || response.status === -1) {
                        $state.go('auth.login');
                        return;
                    }
                    deferred.reject(response);
                });
            };

            queryNext(host + url);

            return deferred.promise;
        }

        function getRequest(url) {
            syncToken();
            var deferred = $q.defer();
            $http.get(host + url).then(function(response) {
                deferred.resolve(response);
            }, function(response) {
                if (response.status === 401 || response.status === -1) {
                    $state.go('auth.login');
                    deferred.reject(response);
                    return;
                }
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function postRequest(url, payload) {
            syncToken();
            return $http.post(host + url, payload);
        }

        function putRequest(url, payload) {
            syncToken();
            return $http.put(host + url, payload);
        }

        function deleteRequest(url) {
            syncToken();
            return $http.delete(host + url);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise('/app/dashboard');

        $stateProvider
            .state('app.register', {
                url: '/register',
                templateUrl: '/app/register/register.html',
                controller: 'RegisterController',
                controllerAs: 'vm',
                resolve: {
                    authUser : authUserResolve
                }
            });


       /** @ngInject */
       function authUserResolve(API) {
           return API.get('authenticate/user');
       }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.register', []);

})();

(function() {
'use strict';

    angular
        .module('app.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($log, $window, $state, $http, toastr, Register) {

        var vm = this;

        vm.form = {};

        vm.submitted = {
            step_one: false,
            step_two: false,
            step_three: false,
            step_four: false,
            step_five: false
        };

        vm.step = 1;

        vm.nextStep = nextStep;
        vm.previousStep = previousStep;

        constructor();

        function constructor() {
            $http.get('/assets/json/states.json').then(function(response) {
                vm.states = response.data;
                $log.debug(vm.states);
            }, function(response) {
                $log.error('There was an issue loading the states json', response);
            })
        }

        function nextStep() {
            if(validateStep(vm.step)) {
                if(vm.step < 5) {
                    vm.step++;
                    $window.scrollTo(0, 0);
                }
                else {
                    submitRegister();
                }
            }
            else {
                toastr.error('Please fill in all required fields.', 'Missing Fields');
            }
        }

        function previousStep() {
            if(vm.step - 1 >= 1)
                vm.step--;
            $window.scrollTo(0, 0);
        }

        function validateStep(step) {
            switch(step) {
                case 1:
                    vm.submitted.step_one = true;
                    if(angular.isDefined(vm.form.first_name) && vm.form.first_name.trim().length > 0 &&
                        angular.isDefined(vm.form.last_name) && vm.form.last_name.trim().length > 0 &&
                        angular.isDefined(vm.form.email) && vm.form.email.trim().length > 0)
                        return true;
                    return false;
                case 2:
                    vm.submitted.step_two = true;
                    return true;
                case 3:
                    var fields = ['address', 'city', 'state', 'postal_code', 'listing_agent', 'lender', 'home_inspector', 'pest_inspector', 'title'];
                    vm.submitted.step_three = true;
                    var valid = true;
                    angular.forEach(fields, function(field) {
                        if(angular.isUndefined(vm.form.buyer[field]) || vm.form.buyer[field].trim().length < 1)
                            valid = false;
                    });
                    return valid;
                case 4:
                    var fields = ['address', 'city', 'state', 'postal_code', 'listing_agent', 'lender', 'home_inspector', 'pest_inspector', 'title'];
                    vm.submitted.step_four = true;
                    var valid = true;
                    angular.forEach(fields, function(field) {
                        if(angular.isUndefined(vm.form.seller[field]) || vm.form.seller[field].trim().length < 1)
                            valid = false;
                    });
                    return valid;
                case 5:
                    vm.submitted.step_five = true;
                    if(vm.form.admin === 'no')
                        return true;
                    if(vm.form.admin === 'yes' && angular.isDefined(vm.form.admin_email) && vm.form.admin_email.length > 0)
                        return true;
                    return false;
            }
            return false;
        }

        function submitRegister() {
            if(vm.registerForm.$valid) {
                $log.debug('Submit', vm.form);
                Register.createClient(vm.form).then(function(response) {
                    toastr.success('Successfully created a new client.', 'Saved');
                    $state.go('app.dashboard', {}, {reload:true});
                }, function(response) {
                    $log.error('There was an issue registering the client.', response);
                    toastr.error('There was an issue saving the client. Please contact support.', 'Error');
                });
            }
            else {
                toastr.error('Please correct the problems with your input.', 'Missing Required Fields');
            }
        }


    }
})();
(function() {
'use strict';

    angular
        .module('app')
        .factory('Role', Role);

    /** @ngInject */
    function Role(API) {

        var service = {
            getAll: getAll
        };

        return service;

        function getAll() {
            return API.getRequest('roles');
        }
    }
})();
(function() {
'use strict';

    angular
        .module('app.register')
        .factory('Register', Register);

    /** @ngInject */
    function Register(API) {

        var service = {
            createClient: createClient,
            getClients: getClients
        };

        return service;

        function createClient(payload) {
            return API.postRequest('proxi/client', payload);
        }

        function getClients() {
            return API.getRequest('proxi/client');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($rootScope, $state, $log, authUser) {

        var vm = this;

        $rootScope.authUser = authUser.data.user;

        vm.goBack = function() {
            $log.debug('[MainCtrl] goBack()', $rootScope.previousState);
            if ($rootScope.previousState && $rootScope.previousState.name && $rootScope.previousState.name.trim().length > 0) {
                $state.go($rootScope.previousState.name, $rootScope.previousState.params);
                return;
            } else {
                var parentState = $state.$current.parent.self.name;
                if (parentState && parentState.trim().length > 0) {
                    $state.go(parentState);
                    return;
                }
                $state.go('app.dashboard');
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise('/app/dashboard');

        $stateProvider
            .state('app.dashboard', {
                url: '/dashboard',
                templateUrl: '/app/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                resolve: {
                    authUser : authUserResolve
                }
            });


       /** @ngInject */
       function authUserResolve(API) {
           return API.get('authenticate/user');
       }

    }

})();

(function() {
'use strict';

    angular
        .module('app')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($log, toastr, Register) {

        var vm = this;

        constructor();

        function constructor() {
            Register.getClients().then(function(response) {
                vm.clients = [].concat(response.data);
                vm.displayedClients = [].concat(vm.clients);
            }, function(response) {
                $log.error('There was an issue loading the clients.', response);
                toastr.error('There was an issue loading the clients. Please contact support.', 'Error');
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.auth', []);

})();

(function() {
    'use strict';

    angular
        .module('app.auth')
        .controller('UserRegisterController', UserRegisterController);

    /** @ngInject */
    function UserRegisterController($log, SweetAlert, Auth, $rootScope, $state, toastr, Role) {

        var vm = this;

        vm.submitted = false;
        vm.register = register;

        vm.form = {
            email: '',
            password: ''
        };

        constructor();

        function constructor() {
            Role.getAll().then(function(response) {
                vm.roles = response.data;
            }, function(response) {
                $log.error('There was an issue loading the roles', response);
                toastr.error('There was an issue loading the user roles. Please contact support.', 'Error');
            });
        }

        function register() {
            vm.submitted = true;
            if(vm.registerForm.$valid) {
                if(vm.form.password !== vm.form.confirm_password) {
                    toastr.error('Your passwords do not match. Please correct your input.', 'Error');
                    return;
                }
                Auth.registerUser(vm.form).then(function(response) {
                    toastr.success('You have successfully registered your account. Please login now.', 'Success');
                    $state.go('auth.login', {}, {reload:true});
                }, function(response) {
                    $log.error('There was an issue registering th user.', response);
                    if(response.status === 406) {
                        toastr.error('There is already an account registered to this email. Please login or use a different email.', 'Error');
                    }
                    else {
                        toastr.error('There was an issue registering the user. Please contact support.', 'Error');
                    }
            });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($log, SweetAlert, Auth, $http, $rootScope, $state) {
        var vm = this;

        vm.submitted = false;
        vm.login = login;
        vm.form = {
            email: '',
            password: ''
        };

        function login() {
            vm.submitted = true;
            if(vm.loginForm.$valid) {
                Auth.attemptLogin(vm.form).then(function(response) {
                    sessionStorage.setItem('token', response.token);
                    Auth.getAuthUser().then(function(response) {
                        $rootScope.user = response.user;
                        $state.go('app.dashboard');
                    });
                }, function(response) {
                    if(response.status === 401) {
                        if (response.data.attempts==5){
                         SweetAlert.swal({
                            title: "Account Locked",
                            text: "You are out of attempts. This account has been locked for 15 minutes.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                         });
                        }
                        else {
                         SweetAlert.swal({
                            title: "Invalid Credentials",
                            text: "You have used attempt "+response.data.attempts+" of 5.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                         });
                        }
                    }
                    if(response.status === 423) {
                         SweetAlert.swal({
                            title: "Account Locked",
                            text: "This account has been locked for 15 minutes.",
                            type: "error",
                            confirmButtonColor: "#007AFF"
                        });
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.auth')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider

            .state('auth', {
                url: '/auth',
                template: '<ui-view/>',
                abstract: true
            })

            .state('auth.login', {
                url: '/login',
                templateUrl: '/app/auth/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })

            .state('auth.register', {
                url: '/register',
                templateUrl: '/app/auth/register.html',
                controller: 'UserRegisterController',
                controllerAs: 'vm'
            })

            .state('auth.logout', {
                url: '/logout',
                controller: function($state) {
                    sessionStorage.removeItem('token');
                    $state.go('auth.login');
                },
                controllerAs: 'vm'
            });

    }

})();

(function() {
    'use strict';

    angular.module('app.auth')
        .factory('Auth', Auth);

    /** @ngInject */
    function Auth($log, $q, API) {

        var factory = {
            getAuthUser: getAuthUser,
            attemptLogin: attemptLogin,
            registerUser: registerUser
        };

        return factory;

        function getAuthUser() {
            var deferred = $q.defer();
            API.getRequest('authenticate/user').then(function(response) {
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('Error loading authorized user.', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function attemptLogin(payload) {
            var deferred = $q.defer();
            API.postRequest('authenticate/auth', payload).then(function(response) {
                $log.debug('[Auth] attemptLogin()', response);
                deferred.resolve(response.data);
            }, function(response) {
                $log.error('[Auth] attemptLogin()', response);
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function registerUser(payload) {
            return API.postRequest('register', payload);
        }

    }

})();
(function() {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $stateParams) {

        // Set some reference to access them from any scope
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        // GLOBAL APP SCOPE
        // set below basic information
        $rootScope.app = {
            name: 'Proxi', // name of your project
            author: 'Zac Folsom', // author's name or company name
            description: '', // brief description
            version: '0.1.0', // current version
            year: ((new Date()).getFullYear()), // automatic current year (for copyright information)
            isMobile: (function() { // true if the browser is a mobile device
                var check = false;
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    check = true;
                }
                return check;
            })(),
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $urlRouterProvider.otherwise('/app/dashboard');

        $stateProvider
            .state('app', {
                url: '/app',
                controller: 'MainController',
                controllerAs: 'main',
                templateUrl: '/app/main/main.html',
                resolve: {
                    authUser : authUserResolve
                }
            })
            .state('403', {
                url: '/403',
                templateUrl: '/app/auth/403.html'
            });


       /** @ngInject */
       function authUserResolve(API) {
           return API.get('authenticate/user');
       }

    }

})();

/* global */
(function() {
    'use strict';

    angular
        .module('app')
        .constant('APP_MEDIAQUERY', {
            'desktopXL': 1200,
            'desktop': 992,
            'tablet': 768,
            'mobile': 480
        });

})();

(function() {
    'use strict';

    angular
        .module('app')
        .config(appConfig)
        .config(cfgLoadingBarConfig)

    /** @ngInject */
    function appConfig($logProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
    }

    function cfgLoadingBarConfig(cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.includeSpinner = false;
    }

     angular
        .module('smart-table')
        .run(smartTableConfig);

    /**
     * Injects a custom pagination template, overriding smart table's default template
     * @ngInject
     * @param  {[type]} $templateCache [description]
     */
    function smartTableConfig($templateCache) {
        $templateCache.put('template/smart-table/pagination.html', [
            '<div class="pagination core--table--footer" ng-if="pages.length >= 2">',
                '<ul class="pagination">',
                    '<li ng-class="{ active: currentPage == 1 }">',
                        '<a ng-click="selectPage(1)">',
                            '<span aria-hidden="true">1</span>',
                        '</a>',
                    '</li>',
                    '<li>',
                        '<a ng-click="selectPage(currentPage-1)" aria-label="Previous" ng-if="currentPage != 1 && numPages > 4">',
                            '<span aria-hidden="true">&larr;</span>',
                        '</a>',
                    '</li>',
                    '<li ng-repeat="page in pages" ng-class="{ active: page == currentPage }" ng-if="page != 1 && page != numPages">',
                        '<a ng-click="selectPage(page)">{{ page }}</a>',
                    '</li>',
                    '<li>',
                        '<a ng-click="selectPage(currentPage+1)" ng-if="currentPage != numPages && numPages > 4">',
                            '<span aria-hidden="true">&rarr;</span>',
                        '</a>',
                    '</li>',
                    '<li ng-class="{ active: currentPage == pages.length }">',
                        '<a href="" ng-click="selectPage(numPages)" aria-label="Last">',
                            '<span aria-hidden="true">{{ numPages }}</span>',
                        '</a>',
                    '</li>',
                '</ul>',
            '</div>'
        ].join(''));
    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("/app/auth/403.html","<div class=\"page-error\"><div class=\"error-number text-red\">403</div><h1 class=\"text-red\">Access Denied</h1><div class=\"error-details top-spacer-1\"><h4>Please contact your administrator to receive access to this page.</h4><button type=\"button\" ui-sref=\"auth.login\" class=\"btn btn-danger\">Return to Login</button></div></div>");
$templateCache.put("/app/auth/login.html","<div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"login-container\"><div class=\"text-center\"><div class=\"logo\"><h4>Proxi</h4></div><p class=\"text-extra-large top-spacer-1\">Login to access your account.</p></div><form name=\"vm.loginForm\" ng-submit=\"vm.login()\" novalidate=\"\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.loginForm.email.$invalid}\"><label class=\"control-label\">Email</label> <input type=\"text\" class=\"input-lg form-control\" ng-model=\"vm.form.email\" name=\"email\" required=\"\" placeholder=\"Email Address\" ng-enter=\"vm.login()\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.loginForm.email.$invalid\"><p class=\"text-danger\">Please enter a valid email address.</p></div></div><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.loginForm.email.$invalid}\"><label class=\"control-label\">Password</label> <input type=\"password\" class=\"input-lg form-control\" ng-model=\"vm.form.password\" name=\"password\" required=\"\" placeholder=\"Password\" ng-enter=\"vm.login()\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.loginForm.password.$invalid\"><p class=\"text-danger\">Please enter a password.</p></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"vm.login()\" class=\"btn btn-success btn-lg btn-block\">Log in</button></div><p class=\"text-center\">Don\'t have an account? <a ui-sref=\"auth.register\">Sign up here.</a></p></form></div><p class=\"text-center top-spacer-1\">&copy; {{app.year}} <span class=\"text-bold text-uppercase\">{{ app.author }}</span>. <span translate=\"footer.copyright.MESSAGE\">All rights reserved</span></p></div></div>");
$templateCache.put("/app/auth/register.html","<div class=\"row\"><div class=\"col-md-6 col-md-offset-3\"><div class=\"login-container\"><div class=\"text-center\"><div class=\"logo\"><h4>Proxi</h4></div><p class=\"text-extra-large top-spacer-1\">Proxi is a website designed to connect the many parts of the real estate process to better the experience for the client and the professionals. Imagine a virtual secretary that is able to keep everyone informed of what they need to know:</p></div><form name=\"vm.registerForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.registerForm.first_name.$invalid}\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.first_name\" name=\"first_name\" required=\"\" placeholder=\"First Name\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.registerForm.first_name.$invalid\"><p class=\"text-danger\">Please enter your first name.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.registerForm.last_name.$invalid}\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.last_name\" name=\"last_name\" required=\"\" placeholder=\"Last Name\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.registerForm.last_name.$invalid\"><p class=\"text-danger\">Please enter your last name.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.registerForm.email.$invalid}\"><label class=\"control-label col-sm-2\">Email</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.email\" name=\"email\" required=\"\" placeholder=\"Email Address\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.registerForm.email.$invalid\"><p class=\"text-danger\">Please enter a valid email address.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.registerForm.password.$invalid}\"><label class=\"control-label col-sm-2\">Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.form.password\" name=\"password\" required=\"\" placeholder=\"Password\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.registerForm.password.$invalid\"><p class=\"text-danger\">Please enter a password.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\" ng-class=\"{\'has-error\' : vm.submitted && vm.registerForm.confirm_password.$invalid}\"><label class=\"control-label col-sm-2\">Confirm Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"vm.form.confirm_password\" name=\"confirm_password\" required=\"\" placeholder=\"Confirm Password\"><div class=\"help-block\" ng-if=\"vm.submitted && vm.registerForm.confirm_password.$invalid\"><p class=\"text-danger\">Please enter a password.</p></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h5 class=\"text-center\">What is your profession?</h5><div class=\"form-group\"><div class=\"col-md-12\"><div class=\"radio\" ng-repeat=\"role in vm.roles\"><label><input type=\"radio\" ng-model=\"vm.form.role\" value=\"{{ role.identity }}\" name=\"profession\"> {{ role.name }}</label></div></div></div><p class=\"text-center\"><em>***If you are a client use the link associated with your agent.***</em></p></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"vm.register()\" class=\"btn btn-success btn-lg btn-block\">Register</button></div></form></div><p class=\"text-center top-spacer-1\">&copy; {{app.year}} <span class=\"text-bold text-uppercase\">{{ app.author }}</span>. <span translate=\"footer.copyright.MESSAGE\">All rights reserved</span></p></div></div>");
$templateCache.put("/app/dashboard/dashboard.html","<h1>Dashboard</h1><div st-table=\"vm.displayedClients\" st-safe-src=\"vm.clients\"><div class=\"row\"><div class=\"col-md-3\"><input type=\"search\" class=\"form-control\" st-search=\"\" placeholder=\"Search\"></div></div><table class=\"table table-striped\"><thead><tr><th>Name</th><th>Email</th><th>Type</th><th>Buying Address</th><th>Selling Address</th><th></th></tr></thead><tbody><tr ng-if=\"vm.clients.length === 0\"><td colspan=\"6\" class=\"text-center\">There are currently no clients within the system.</td></tr><tr ng-if=\"vm.displayedClients.length === 0 && vm.clients.length > 0\"><td colspan=\"6\" class=\"text-center\">There are no clients that match your search.</td></tr><tr ng-repeat=\"client in vm.displayedClients\"><td>{{ client.first_name + \' \' + client.last_name }}</td><td>{{ client.email }}</td><td>{{ client.type }}</td><td>{{ client.buying_address + \', \' + client.buying_city + \', \' + client.buying_state + \' \' + client.buying_postal }}</td><td>{{ client.selling_address + \', \' + client.selling_city + \', \' + client.selling_state + \' \' + client.selling_postal }}</td><td></td></tr></tbody></table></div>");
$templateCache.put("/app/main/main.html","<div id=\"wrapper\"><div id=\"sidebar-wrapper\"><ul class=\"sidebar-nav\"><li class=\"sidebar-brand\"><a href=\"#\">Proxi</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.dashboard\">Dashboard</a></li><li><a href=\"#\">CIP</a></li><li><a href=\"#\">Messages</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.register\">Register</a></li><li><a href=\"#\">Connections</a></li><li><a href=\"#\">Updates</a></li><li><a href=\"#\">Help</a></li><li><a ui-sref=\"auth.logout\">Logout</a></li></ul></div><div id=\"page-content-wrapper\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-lg-12\"><h2>Proxi | Real Estate Agent</h2><p>{{ authUser.name }} is connected.</p><hr><div ui-view=\"\"></div></div></div></div></div></div>");
$templateCache.put("/app/register/register.html","<h2 class=\"text-center\">register a new client</h2><form class=\"top-spacer-1\" name=\"vm.registerForm\"><div class=\"jumbotron\"><div class=\"step1\" ng-show=\"vm.step === 1\"><p>Enter the information to create a new client within the system.</p><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_one && vm.registerForm.first_name.$invalid }\"><label class=\"control-label col-sm-2\">First Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.first_name\" name=\"first_name\" placeholder=\"First Name\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_one && vm.registerForm.first_name.$invalid\"><p class=\"text-danger\">First name is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_one && vm.registerForm.last_name.$invalid }\"><label class=\"control-label col-sm-2\">Last Name</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.last_name\" name=\"last_name\" placeholder=\"Last Name\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_one && vm.registerForm.last_name.$invalid\"><p class=\"text-danger\">Last name is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_one && vm.registerForm.email.$invalid }\"><label class=\"control-label col-sm-2\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" ng-model=\"vm.form.email\" name=\"email\" placeholder=\"Email Address\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_one && vm.registerForm.email.$invalid\"><p class=\"text-danger\">Email is a required field.</p></div></div></div></div><div class=\"step2\" ng-show=\"vm.step === 2\"><p>Please select the type of client. The client can be a buyer, seller or both sides.</p><div class=\"form-group row\"><div class=\"col-md-12\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.form.type\" name=\"client_type\" value=\"Buyer\"> Buyer</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.form.type\" name=\"client_type\" value=\"Seller\"> Seller</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.form.type\" name=\"client_type\" value=\"Both\"> Both</label></div></div></div></div><div class=\"step3\" ng-show=\"vm.step === 3\"><p>Please enter the <strong>buying</strong> side\'s information.</p><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_address.$invalid }\"><label class=\"control-label col-sm-2\">Buying address</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.address\" name=\"buyer_address\" placeholder=\"Buyer Address\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_address.$invalid\"><p class=\"text-danger\">Buyer address is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_city.$invalid }\"><label class=\"control-label col-sm-2\">City</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.city\" name=\"buyer_city\" placeholder=\"City\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_city.$invalid\"><p class=\"text-danger\">City is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_state.$invalid }\"><label class=\"control-label col-sm-2\">State</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.form.buyer.state\" name=\"buyer_state\" ng-options=\"state for state in vm.states\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">State</option></select><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_state.$invalid\"><p class=\"text-danger\">State is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_postal_code.$invalid }\"><label class=\"control-label col-sm-2\">Zip</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.postal_code\" name=\"buyer_postal_code\" placeholder=\"Zip\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_postal_code.$invalid\"><p class=\"text-danger\">Zip is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_listing_agent.$invalid }\"><label class=\"control-label col-sm-2\">Listing Agent</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.listing_agent\" name=\"buyer_listing_agent\" placeholder=\"Listing Agent\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_listing_agent.$invalid\"><p class=\"text-danger\">Listing agent is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_lender.$invalid }\"><label class=\"control-label col-sm-2\">Lender</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.lender\" name=\"buyer_lender\" placeholder=\"Lender\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_lender.$invalid\"><p class=\"text-danger\">Lender is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_home_inspector.$invalid }\"><label class=\"control-label col-sm-2\">Home Inspector</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.home_inspector\" name=\"buyer_home_inspector\" placeholder=\"Home Inspector\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_home_inspector.$invalid\"><p class=\"text-danger\">Home inspector is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_pest_inspector.$invalid }\"><label class=\"control-label col-sm-2\">Pest Inspector</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.pest_inspector\" name=\"buyer_pest_inspector\" placeholder=\"Pest Inspector\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_pest_inspector.$invalid\"><p class=\"text-danger\">Pest inspector is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_three && vm.registerForm.buyer_title.$invalid }\"><label class=\"control-label col-sm-2\">Title</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.buyer.title\" name=\"buyer_title\" placeholder=\"Title\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_three && vm.registerForm.buyer_title.$invalid\"><p class=\"text-danger\">Title agency is a required field.</p></div></div></div></div><div class=\"step4\" ng-show=\"vm.step === 4\"><p>Please enter the <strong>selling</strong> side\'s information.</p><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_address.$invalid }\"><label class=\"control-label col-sm-2\">Selling address</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.address\" name=\"seller_address\" placeholder=\"Selling Address\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_address.$invalid\"><p class=\"text-danger\">Selling address is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_city.$invalid }\"><label class=\"control-label col-sm-2\">City</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.city\" name=\"seller_city\" placeholder=\"City\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_city.$invalid\"><p class=\"text-danger\">City is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_state.$invalid }\"><label class=\"control-label col-sm-2\">State</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"vm.form.seller.state\" name=\"seller_state\" ng-options=\"state for state in vm.states\" required=\"\"><option value=\"\" disabled=\"\" selected=\"\">State</option></select><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_state.$invalid\"><p class=\"text-danger\">State is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_postal_code.$invalid }\"><label class=\"control-label col-sm-2\">Zip</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.postal_code\" name=\"seller_postal_code\" placeholder=\"Zip\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_postal_code.$invalid\"><p class=\"text-danger\">Zip is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_listing_agent.$invalid }\"><label class=\"control-label col-sm-2\">Listing Agent</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.listing_agent\" name=\"seller_listing_agent\" placeholder=\"Listing Agent\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_listing_agent.$invalid\"><p class=\"text-danger\">Listing agent is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_lender.$invalid }\"><label class=\"control-label col-sm-2\">Lender</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.lender\" name=\"seller_lender\" placeholder=\"Lender\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_lender.$invalid\"><p class=\"text-danger\">Lender is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_home_inspector.$invalid }\"><label class=\"control-label col-sm-2\">Home Inspector</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.home_inspector\" name=\"seller_home_inspector\" placeholder=\"Home Inspector\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_home_inspector.$invalid\"><p class=\"text-danger\">Home inspector is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_pest_inspector.$invalid }\"><label class=\"control-label col-sm-2\">Pest Inspector</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.pest_inspector\" name=\"seller_pest_inspector\" placeholder=\"Pest Inspector\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_pest_inspector.$invalid\"><p class=\"text-danger\">Pest inspector is a required field.</p></div></div></div><div class=\"row form-group\" ng-class=\"{\'has-error\' : vm.submitted.step_four && vm.registerForm.seller_title.$invalid }\"><label class=\"control-label col-sm-2\">Title</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.seller.title\" name=\"seller_title\" placeholder=\"Title\" required=\"\"><div class=\"help-block\" ng-show=\"vm.submitted.step_four && vm.registerForm.seller_title.$invalid\"><p class=\"text-danger\">Title agency is a required field.</p></div></div></div></div><div class=\"step5\" ng-show=\"vm.step === 5\"><p>Please indicate if you have an admin.</p><div class=\"form-group row\"><div class=\"col-md-12\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.form.admin\" value=\"yes\" name=\"admin\"> Yes</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.form.admin\" value=\"no\" name=\"admin\"> No</label></div></div></div><div class=\"form-group row\" ng-show=\"vm.form.admin === \'yes\'\" ng-class=\"{\'has-error\' : vm.submitted.step_five && vm.registerForm.admin.$invalid }\"><label class=\"control-label col-sm-2\">Admin</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.form.admin_email\" name=\"admin_email\" placeholder=\"Admin\" ng-required=\"vm.form.admin === \'yes\'\"><div class=\"help-block\" ng-show=\"vm.submitted.step_five && vm.registerForm.admin_email.$invalid\"><p class=\"text-danger\">Admin email is a required field.</p></div></div></div></div><ul class=\"pager\"><li class=\"previous\" ng-class=\"{\'disabled\' : vm.step === 1}\"><a ng-click=\"vm.previousStep()\" ng-disabled=\"vm.step === 1\">Previous</a></li><li class=\"next\"><a ng-click=\"vm.nextStep()\">{{ vm.step < 5 ? \'Next\' : \'Register\' }}</a></li></ul></div></form>");}]);